import { ApiError } from './api';
import { hasString, useI18n } from './i18n';

/**
 * Turns a failed request into a sentence the reader understands.
 *
 * Translation is by the server's stable error code, not by its English text.
 * The API stays in one language, which keeps its logs and its contract simple,
 * while the screen speaks whichever language the person chose. A code with no
 * translation yet falls back to the server's own wording rather than showing
 * nothing — a message in the wrong language still beats a blank box.
 */
export function useApiError(): (error: unknown) => string | null {
  const { t } = useI18n();

  return (error: unknown) => {
    if (!(error instanceof ApiError)) return null;
    const key = `error.${error.code}`;
    return hasString(key) ? t(key) : error.message;
  };
}
